import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { menuCategories, restaurantInfo } from '../data/mock';

const MenuSection = () => {
  return (
    <section id="cardapio" className="section-padding bg-stone-50 relative overflow-hidden" aria-labelledby="menu-heading">
      {/* Background decorations */}
      <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-neutral-950 to-transparent" />
      
      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 pt-8">
          <span className="text-amber-700 font-medium tracking-widest uppercase text-sm">
            Nossos Pratos
          </span>
          <h2 id="menu-heading" className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-neutral-900 mt-4 mb-6">
            Cardápio Japonês
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-700 to-amber-500 mx-auto mb-6" />
          <p className="text-neutral-600 text-lg max-w-2xl mx-auto">
            Descubra nossa seleção de sushi em Anápolis preparados com os ingredientes mais frescos e técnicas tradicionais japonesas.
          </p>
        </div>

        {/* Menu Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6 mb-12">
          {menuCategories.map((category) => (
            <article
              key={category.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
            >
              {/* Image */}
              <figure className="relative h-56 overflow-hidden">
                <img
                  src={category.image}
                  alt={category.altText}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
                
                {/* Category badge */}
                <figcaption className="absolute bottom-4 left-4">
                  <span className="bg-amber-700 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {category.name}
                  </span>
                </figcaption>
              </figure>

              {/* Content */}
              <div className="p-6">
                <h3 className="font-serif text-2xl font-bold text-neutral-900 mb-2">
                  {category.name}
                </h3>
                <p className="text-neutral-600 mb-4">
                  {category.description}
                </p>
                
                {/* Items list */}
                <ul className="space-y-2 mb-4">
                  {category.items.slice(0, 3).map((item, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-sm text-neutral-500">
                      <span className="w-1.5 h-1.5 bg-amber-600 rounded-full" aria-hidden="true" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <Button
            size="lg"
            className="bg-neutral-900 hover:bg-neutral-800 text-white font-semibold px-10 py-6 text-lg btn-hover-lift flex items-center gap-2 mx-auto"
            onClick={() => window.open(restaurantInfo.menuUrl, '_blank')}
            aria-label="Ver cardápio completo do Japamix"
          >
            Ver Cardápio Completo
            <ArrowRight size={20} aria-hidden="true" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default MenuSection;
